import router from '../router'
import moment from 'moment'

export function pagePush (path) {
  router.push(path)
}

export function sliceArray (arr, arrLength) {
  let index = 0
  let newArr = []
  while (index < arr.length) {
    newArr.push(arr.slice(index, index += arrLength))
  }
  return newArr
}

export function formatArr (payload, list) {
  let arr = []
  if (payload.length < 8) {
    payload.map(item => {
      let array = []
      list.length && list.map(it => {
        // 兼容不同数据源的时间字段：在线课程、SVIP、1v1教师待上课
        let curTime = it.courseBeginTime || it.lessonBeginTime || it.startTime || it.lessonStartTime
        let date = moment(curTime).format('YYYY-MM-DD')
        if (item.date === date) array.push(it)
      })
      arr.push(array)
    })
  } else {
    arr = payload.map(item => {
      item.course = []
      list.length && list.map(it => {
        // 兼容不同数据源的时间字段：在线课程、SVIP、1v1教师待上课
        let curTime = it.courseBeginTime || it.lessonBeginTime || it.startTime || it.lessonStartTime
        let date = moment(curTime).format('YYYY-MM-DD')
        if (item.date === date) item.course.push(it)
      })
      return item
    })
    arr = sliceArray(arr, 7)
  }
  return arr
}

export const getSystemInfo = userAgent => {
  if (!userAgent && navigator) {
    userAgent = navigator.userAgent
  }
  var info = {
    browser: '',
    browser_version: '',
    systemType: '',
    system_version: ''
  }
  // 获取浏览器类型、版本
  var isOpera = userAgent.indexOf('Opera') > -1 // 判断是否Opera浏览器
  var isIE = userAgent.indexOf('compatible') > -1 &&
    userAgent.indexOf('MSIE') > -1 && !isOpera // 判断是否IE浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 // 判断是否IE的Edge浏览器
  var isFF = userAgent.indexOf('Firefox') > -1 // 判断是否Firefox浏览器
  var isSafari = userAgent.indexOf('Safari') > -1 &&
    userAgent.indexOf('Chrome') == -1 // 判断是否Safari浏览器
  var isChrome = userAgent.indexOf('Chrome') > -1 &&
    userAgent.indexOf('Safari') > -1 // 判断Chrome浏览器
  if (isIE) {
    info.browser = 'IE'
    let reg = new RegExp('MSIE ([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  } else if (isOpera) {
    info.browser = 'Opera'
    let reg = new RegExp('Opera/([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  } else if (isEdge) {
    info.browser = 'Edge'
    let reg = new RegExp('Edge/([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  } else if (isFF) {
    info.browser = 'Firefox'
    let reg = new RegExp('Firefox/([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  } else if (isSafari) {
    info.browser = 'Safari'
    let reg = new RegExp('Safari/([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  } else if (isChrome) {
    info.browser = 'Chrome'
    let reg = new RegExp('Chrome/([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.browser_version = RegExp['$1']
    }
  }

  // 获取系统类型、版本
  var isAndroid = userAgent.indexOf('Android') > -1
  var isIPhone = userAgent.indexOf('iPhone') > -1
  var isWindows = userAgent.indexOf('Windows') > -1
  var isIOS = userAgent.indexOf('Mac OS X') > -1 && !isIPhone
  var isLinux = userAgent.indexOf('Linux') > -1 && !isAndroid
  if (isAndroid) {
    info.systemType = 'Android'
    let reg = new RegExp('Android ([\\d\\.]+)')
    if (reg.test(userAgent)) {
      info.system_version = RegExp['$1']
    }
  } else if (isIOS) {
    info.systemType = 'iOS'
    let reg = new RegExp('Mac OS X ([\\d\\._]+)')
    if (reg.test(userAgent)) {
      info.system_version = RegExp['$1']
    }
  } else if (isIPhone) {
    info.systemType = 'iPhone'
    let reg = new RegExp('iPhone OS ([\\d\\._]+)')
    if (reg.test(userAgent)) {
      info.system_version = RegExp['$1']
    }
  } else if (isLinux) {
    info.systemType = 'Linux'
  } else if (isWindows) {
    info.systemType = 'Windows'
    let reg = new RegExp('Windows NT ([\\d\\._]+)')
    if (reg.test(userAgent)) {
      info.system_version = RegExp['$1']
    }
  }
  return info
}

// 下载文件
export function commonDownload (url, name) {
  let a = document.createElement('a')
  a.href = url
  a.download = name || '课件'
  if (document.createEvent) {
    var e = document.createEvent('MouseEvents')
    e.initEvent('click', true, true)
    a.dispatchEvent(e)
  }
}

// 图片转base64
export function toBase64 (url, fileType, callback) {
  let Img = new Image()
  let dataURL = ''
  Img.src = url
  Img.setAttribute('crossOrigin', 'Anonymous')
  Img.onload = function () {
    let canvas = document.createElement('canvas') // 创建canvas元素
    canvas.width = Img.width // 确保canvas的尺寸和图片一样
    canvas.height = Img.height
    canvas.getContext('2d').drawImage(Img, 0, 0, Img.width, Img.height) // 将图片绘制到canvas中
    dataURL = canvas.toDataURL('image/' + fileType) // 转换图片为dataURL
    if (callback) callback(dataURL)
  }
}

// 处理文件流并导出
export function exportBlob (data, name) {
  const link = document.createElement('a')
  const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  link.setAttribute('download', `${name}.xls`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}



// WEBPACK FOOTER //
// ./src/utils/util.js